import { render, staticRenderFns } from "./ServiceEntitlementAccrual.vue?vue&type=template&id=5055535b&"
import script from "./ServiceEntitlementAccrual.vue?vue&type=script&lang=js&"
export * from "./ServiceEntitlementAccrual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports